export default {
  inserted(el) {
    el.classList.add('animate__animated'); // 기본 클래스
    el.style.opacity = 0;

    const observer = new IntersectionObserver(
      ([entry], observer) => {
        if (entry.isIntersecting) {
          el.classList.add('animate__fadeInUp', 'animate__faster');
          el.style.setProperty('animation-timing-function', 'ease-out', 'important');
          el.style.opacity = 1;
          observer.unobserve(el); // 1회만 실행
        }
      },
      {
        threshold: 0.1,
      }
    );

    observer.observe(el);
  },
};